import {PropsWithChildren} from "react";
import {Box, Divider, Stack, Typography} from "@mui/material";

export interface Props extends PropsWithChildren {
    header: string;
}

export const KeyValuePair: React.FC<Props> = ({header, children}) => (
    <Stack direction="column">
        <Typography textTransform="uppercase" sx={{color: "#737990"}} fontSize={14}>
            {header}
        </Typography>
        <Divider sx={{marginBottom: "0.6rem"}} />
        <Box fontSize={16}>{children}</Box>
    </Stack>
);
